<template>
  <BaseModal
    title="Tabelle konfigurieren"
    v-if="show"
    @close="close"
    min-height="none"
  >
    <template v-slot:content>
      <p class="mb-8">
        Hier können Sie auswählen, welche Spalten in der Tabelle angezeigt
        werden und per Drag and Drop die Spalten in die gewünschte Reihenfolge
        bringen.
      </p>
      <div class="columnOrder">
        <Container @drop="onDrop" orientation="horizontal" :key="key">
          <Draggable
            v-for="(column, index) in draggableColumns"
            :key="column.index"
          >
            <div class="draggable-item">
              <BaseCheckbox
                :value="column.visible"
                :label="column.label"
                @update="update(index, $event)"
                class="pr-0"
              />
            </div>
          </Draggable>
        </Container>
      </div>
      <BaseButton
        outlined
        rounded
        highlight
        size="xs"
        class="w-fit m-auto"
        @click.native="save"
      >
        Änderungen übernehmen
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import { Container, Draggable } from 'vue-dndrop';

export default {
  name: 'ColumnOrder',
  components: {
    Container,
    Draggable,
  },
  props: {
    columns: Array,
    show: Boolean,
  },
  data() {
    return {
      draggableColumns: [],
      key: 0,
    };
  },
  methods: {
    applyDrag: (arr, dragResult) => {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;

      const result = [...arr];
      let itemToAdd = payload;

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      return result;
    },
    onDrop(dropResult) {
      this.draggableColumns = this.applyDrag(this.draggableColumns, dropResult);
    },
    save() {
      this.$emit('change', this.draggableColumns);
    },
    close() {
      this.$emit('close');
    },
    update(index, data) {
      this.draggableColumns[index].visible = data;
      this.key++;
    },
  },
  watch: {
    columns() {
      this.draggableColumns = [...this.columns];
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.card) {
  min-height: 300px;
}

.columnOrder {
  margin-bottom: 30px;
  width: 100%;
  overflow: auto;
  height: 350px;
  max-height: 100%;
}

.dndrop-container {
  height: 100%;
}

.dndrop-draggable-wrapper {
  height: 350px;
  .draggable-item {
    height: 100%;
    cursor: pointer;
    padding: 15px 22px;
    background-color: #f2f2f2;
    margin-right: 10px;
  }

  &:last-child .draggable-item {
    margin-right: 0;
  }
}
</style>
